export default "__VITE_ASSET__cf3fd0f7__"